import React, { useState } from "react";
import { Check } from "lucide-react";
import { DIRECTORY } from "../mock";

const TABS = Object.keys(DIRECTORY);

const CareDirectory = () => {
  const [active, setActive] = useState(TABS[0]);

  return (
    <section className="py-20 md:py-28 px-5 md:px-8 bg-[#1B2A4A]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto fade-up">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-px w-6 bg-[#8FCBC5]" />
            <span className="text-[12px] font-bold tracking-[0.16em] text-[#8FCBC5] uppercase">
              Complete Care Directory
            </span>
            <span className="h-px w-6 bg-[#8FCBC5]" />
          </div>
          <h2 className="font-heading font-extrabold text-white text-[32px] md:text-[42px] leading-tight">
            Every kind of care, under one trusted roof
          </h2>
          <p className="text-[#a9b6c4] mt-4 text-[16px] leading-relaxed">
            From daily support and clinical procedures to complex critical care —
            Healthsqur brings hospital-grade services home. Explore the categories
            below.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mt-12 fade-up">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`px-5 py-2.5 rounded-full text-[14px] font-semibold transition-all ${
                active === t
                  ? "bg-[#159A90] text-white shadow-[0_8px_20px_rgba(21,154,144,0.4)]"
                  : "bg-white/10 text-[#c4cfdb] hover:bg-white/20"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* Items */}
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {DIRECTORY[active].map((item) => (
            <div
              key={item}
              className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl px-4 py-3 hover:bg-white/10 hover:border-[#159A90]/50 transition-all"
            >
              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#159A90]/20">
                <Check size={12} className="text-[#8FCBC5]" />
              </span>
              <span className="text-[14px] text-[#dbe3ec]">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareDirectory;
